<template>
  <div class="message-home">
     <MessageHeader @messageChange="handMessageChange"/>
     <MessageList :messageList="messageList" :finished="finished" @updateList="handUpdate" @refresh="handRefresh"/>
  </div>
</template>

<script>
import MessageHeader from './components/MessageHeader.vue'
import MessageList from './components/MessageList.vue'
import { MESSAGE_PROMPT }from '@/utils/constants'
export default {
  components: {
    MessageHeader,
    MessageList
  },
  data() {
    return {
      level:0,
      messageList:[],
      finished:false
    }
  },
  created() {
    this.getMessageList()
  },
  methods: {
    handMessageChange(e){
      this.level = e.e.value
      this.getMessageList()
    },
    getMessageList(){
       let user = JSON.parse(localStorage.getItem('h5userInfo'))
       let params = {
         userId:String(user.id),
         ...MESSAGE_PROMPT,
         pageSize:200,
         currentPage:1,
         level:this.level,
         isRead:-1
       }
       this.$apis.getStationMessageListApi(params).then(res =>{
          if(res){
            const { infos,total } = res
            this.messageList = infos
            if(infos.length <= total){
              this.finished = true
            }else{
              this.finished = false
            }
          }
       })
    },
    handUpdate(e){
      if(e){
        // this.getMessageList();
      }
    },
    handRefresh(e){
      if(e){
        this.loading = false
      }
    }
  }
};
</script>

<style scoped lang="less">
   .message-home{
     background: #FAFAFA;
   }
</style>
